import React, { useEffect } from "react";
import { NotificationManager } from "react-notifications";
import LoadMask from "../../../../../Utils/LoadMask/LoadMask";
import Modal from "react-responsive-modal";
import { HistoricoInventariosApi } from "../api/HistoricoInventariosApi";
import { Controller, useForm } from "react-hook-form";
import DatePicker from "react-datepicker";
import {
    dateToDayStart,
    getErrorFromResponse,
} from "../../../../../../../utility/utils";
import moment from "moment";

export const FormInventario = (props) => {
    const { opened, onClose, navigateToCreacion, fechaInicial } = props;

    // formulario
    const {
        control,
        formState: { errors },
        getValues: formGetValues,
        setValue: formSetValue,
        watch,
        trigger: validateForm,
    } = useForm({
        defaultValues: {
            fecha_inicial: fechaInicial,
            fecha_final: null,
        },
    });

    const { crearInventario, cargando } = HistoricoInventariosApi();

    const CrearInventario = async () => {
        try {
            const isValid = await validateForm();
            if (!isValid) {
                return;
            }

            const fecha_inicial = formGetValues("fecha_inicial");
            const fecha_final = formGetValues("fecha_final");

            // sumar 1 día a la fecha final para que incluya el día seleccionado
            const realFechaFinal = moment(fecha_final).add(1, "day");

            const data = {
                fecha_inicial: dateToDayStart(fecha_inicial),
                fecha_final: dateToDayStart(realFechaFinal),
            };
            const inventarioCreado = await crearInventario(data);

            NotificationManager.success(
                "Historico de inventario creado correctamente",
                "Éxito",
                3000,
            );

            navigateToCreacion(inventarioCreado.id);
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al crear historico de inventario",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    const fechaFinal = watch("fecha_final");

    useEffect(() => {
        if (fechaInicial) {
            formSetValue("fecha_inicial", moment(fechaInicial));
        }
    }, [fechaInicial, formSetValue]);

    return (
        <Modal
            open={opened}
            onClose={onClose}
            closeOnOverlayClick={!cargando}
            focusTrapped={false}
        >
            <LoadMask loading={cargando} blur>
                <h2 className="text-center">Ingresar periodo del inventario</h2>

                {/* Pesos */}
                <div className="formulario-fields-row">
                    <div className="formulario-field">
                        <label htmlFor="fecha_inicial" className="m-0">
                            Fecha inicial
                        </label>

                        <div className="d-flex align-items-center">
                            <div className="flex-1">
                                <Controller
                                    name="fecha_inicial"
                                    control={control}
                                    rules={{
                                        required:
                                            "La fecha inicial es obligatoria",
                                    }}
                                    render={({ field }) => (
                                        <DatePicker
                                            selected={field.value}
                                            onChange={(date) => {
                                                field.onChange(date);
                                            }}
                                            showPopperArrow={false}
                                            dateFormat="DD/MM/YYYY"
                                            placeholderText="Fecha de inicio"
                                            maxDate={fechaFinal}
                                            autoFocus={false}
                                            disabled
                                        />
                                    )}
                                />
                                {errors.fecha_inicial && (
                                    <small className="text-danger">
                                        {errors.fecha_inicial.message}
                                    </small>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="formulario-field">
                        <label htmlFor="fecha_final" className="m-0">
                            Fecha final
                        </label>

                        <div className="d-flex align-items-center">
                            <div className="flex-1">
                                <Controller
                                    name="fecha_final"
                                    control={control}
                                    rules={{
                                        required:
                                            "La fecha final es obligatoria",
                                        validate: (value) =>
                                            !fechaInicial ||
                                            !value ||
                                            moment(value).isSameOrAfter(
                                                fechaInicial,
                                            ) ||
                                            "La fecha final debe ser posterior a la fecha inicial",
                                    }}
                                    render={({ field }) => (
                                        <DatePicker
                                            selected={field.value}
                                            onChange={(date) => {
                                                field.onChange(date);
                                            }}
                                            showPopperArrow={false}
                                            dateFormat="DD/MM/YYYY"
                                            placeholderText="Fecha de fin"
                                            minDate={moment(fechaInicial)}
                                            autoFocus={false}
                                        />
                                    )}
                                />
                                {errors.fecha_final && (
                                    <small className="text-danger">
                                        {errors.fecha_final.message}
                                    </small>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    className="d-flex flex-wrap justify-content-center mt-4 mb-2"
                    style={{ gap: "1rem" }}
                >
                    <button
                        className="btn btn-outline-dark"
                        onClick={onClose}
                        disabled={cargando}
                    >
                        Regresar
                    </button>
                    <button
                        className="btn btn-primary"
                        onClick={CrearInventario}
                    >
                        Crear inventario
                    </button>
                </div>
            </LoadMask>
        </Modal>
    );
};
